<template>
  <div >
    <b>{{title}}:</b>
    <hr>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'TitleComponent',
  data () {
    return {

    }
  },
  props:{
    title: String,

  },
}
</script>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/shared/TitleComponent.vue